import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { INTERACTIVE_ANALYTICS_GOVERNANCE } from '../../../../content/enterpriseMessaging';
import GovernanceLayerStack from './GovernanceLayerStack';
import { PBISection } from './PBIContent';

export default function AnalyticsGovernanceSection() {
  const copy = INTERACTIVE_ANALYTICS_GOVERNANCE;

  return (
    <PBISection accent="neutral" id="analytics-governance" tight>
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-x-16 lg:gap-y-10 lg:items-center">
        <div className="lg:order-2 lg:pl-4">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">{copy.title}</h2>
          <p className="mt-4 text-base leading-relaxed text-ink-600">{copy.body}</p>
          <ul className="mt-6 space-y-2.5">
            {copy.bullets.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm text-ink-600 leading-relaxed">
                <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:order-1 flex w-full items-center justify-center lg:justify-start">
          <div className="w-full max-w-none scale-100 sm:scale-105 lg:scale-[1.12] lg:origin-left">
            <GovernanceLayerStack />
          </div>
        </div>
      </div>
    </PBISection>
  );
}
